import React from 'react'
import {useState} from "react";
import {Navigate, useNavigate} from 'react-router-dom'
import axiosInstance from "./config/axiosInstance";
import appixiLogo from './assets/appixi_logo.png'

// Markup follows rock-dashboard src/pages/LoginPage.js.
function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setSubmitting] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSubmitting(true);
        try {
            const formData = new FormData();
            formData.append('email', email);
            formData.append('password', password);
            const response = await axiosInstance.post('/auth/login', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            const token = response.data?.access_token ?? '';
            if (!response.data?.success || !token) {
                setError(response.data?.message ?? 'Invalid username or password');
            } else {
                localStorage.setItem('token', token);
                setError('');
                navigate('portal/fairy-ai-list');
            }
        } catch (error) {
            console.error('Login failed:', error);
            setError('Login failed. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    // Already signed in: skip the form
    if (localStorage.getItem('token')) return <Navigate to="/portal/dashboard" replace />;

    return (
        <div className="page page-center">
            <div className="container container-tight py-4">
                <div className="text-center mb-4">
                    <img src={appixiLogo} alt="" width={48} height={48} />
                </div>
                <div className="card card-md">
                    <div className="card-body">
                        <h2 className="h2 text-center mb-4">Sign in to Appixi Admin</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label" htmlFor="login-email">Email</label>
                                <input
                                    id="login-email"
                                    type="email"
                                    className="form-control"
                                    placeholder="you@example.com"
                                    autoComplete="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label" htmlFor="login-password">Password</label>
                                <input
                                    id="login-password"
                                    type="password"
                                    className="form-control"
                                    placeholder="Your password"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            {error && <div className="login-error small mb-3">{error}</div>}
                            <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                                Sign in
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login
